export default class Document {

  constructor() {
    this.title = ''
    this.description = ''
    this.file = ''
  }

}